import { isValidElement } from 'react';

import { io } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';

const isFn = (v) => typeof v === 'function';

const hasAction = (action) => isValidElement(action) || isFn(action) || io(action);

const renderAction = (action, type, actionLoadingStates, handleActionClick, handleClose) => {
  if (!action) return null;
  if (isFn(action)) return action({ close: handleClose });
  if (isValidElement(action)) return action;
  if (!io(action)) return null;

  return (
    <Button
      {...action}
      size="xs"
      color="neutral"
      variant="tertiary"
      text={action.text}
      data-qa={action['data-qa']}
      isLoading={actionLoadingStates[type] || action.isLoading}
      isDisabled={action.isDisabled || actionLoadingStates[type]}
      onClick={() => handleActionClick(action.onClick, type, action.closeOnClick)}
    />
  );
};

const Actions = ({ actions, actionLoadingStates = {}, handleActionClick, handleClose }) => {
  if (!hasAction(actions?.primary) && !hasAction(actions?.secondary)) return null;

  return (
    <div className="flex h-fit items-center gap-2">
      {renderAction(
        actions?.secondary,
        'secondary',
        actionLoadingStates,
        handleActionClick,
        handleClose
      )}
      {renderAction(
        actions?.primary,
        'primary',
        actionLoadingStates,
        handleActionClick,
        handleClose
      )}
    </div>
  );
};

export default Actions;
